export interface Alert {
  text: string;
  badge: AlertBadge;
  message?: string;
  infinite?: boolean;
}

export enum AlertBadge {
  I = "--al-i",
  W = "--al-w",
  E = "--al-e",
  S = "--al-s",
}
